import React, { useState, useContext, useEffect } from "react";

import { useForm, Controller } from "react-hook-form";
import { AccountContext } from "context/account";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

import toast from "react-hot-toast";
import { accountTypeOptions, accountStatusOptions } from "utils/data";

const DeleteStyleFromCollectionModal = ({
  visible,
  handleClose,
  product,
  handleOk,
  directDelete = false,
}) => {
  const [deleteOption, setDeleteOption] = useState(directDelete ? "delete" : "remove");

  const collection = product?.collection || {};

  return (
    <Dialog
      open={visible}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle id="alert-dialog-title">Delete Style:{product.title}</DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <SuiBox ml={1.5} lineHeight={0} sx={{ minHeight: 30 }}>
            {directDelete ? (
              <SuiTypography variant="body1" fontWeight="regular" color="dark">
                {collection.id ? `This style belongs to collection:${collection.title}. ` : ""}
                Are you sure to <strong>delete</strong> it?
              </SuiTypography>
            ) : (
              <RadioGroup
                row
                value={deleteOption}
                onChange={(e) => setDeleteOption(e.target.value)}
              >
                <SuiBox display="flex" alignItems="center" mr={1} mb={1}>
                  <Radio value="remove" />
                  <SuiTypography variant="body1" fontWeight="regular" color="dark">
                    This will only remove the style out of collection.
                  </SuiTypography>
                </SuiBox>
                <SuiBox display="flex" alignItems="center" mr={1} mb={1}>
                  <Radio value="delete" />
                  <SuiTypography variant="body1" fontWeight="regular" color="dark">
                    This will remove the style out of collection and <strong>delete</strong> it.
                  </SuiTypography>
                </SuiBox>
              </RadioGroup>
            )}
          </SuiBox>
          <SuiBox
            pt={3}
            px={3}
            display="flex"
            justifyContent="end"
            alignItems={{ xs: "flex-start", sm: "center" }}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
              <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                <SuiButton variant="gradient" size="medium" onClick={handleClose} color="light">
                  Cancel
                </SuiButton>
              </SuiBox>
            </SuiBox>
            <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
              <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                <SuiButton
                  size="medium"
                  variant="gradient"
                  color="error"
                  onClick={() => handleOk(deleteOption)}
                >
                  Delete
                </SuiButton>
              </SuiBox>
            </SuiBox>
          </SuiBox>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteStyleFromCollectionModal;
